import { render, staticRenderFns } from "./MacroIframe.vue?vue&type=template&id=5db3321c&"
import script from "./MacroIframe.vue?vue&type=script&lang=js&"
export * from "./MacroIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lucas/projects/work/autoag/autoagtruck.ch/wp-content/themes/autoag/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5db3321c')) {
      api.createRecord('5db3321c', component.options)
    } else {
      api.reload('5db3321c', component.options)
    }
    module.hot.accept("./MacroIframe.vue?vue&type=template&id=5db3321c&", function () {
      api.rerender('5db3321c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/scripts/MacroIframe/MacroIframe.vue"
export default component.exports